import React from "react"
import Image from "../image"

class WhyPicks extends React.Component {
  render() {
    return (
      <div className="why-picks">
        <div className="container is-slim">
          <div data-aos="fade-up" className="has-text-centered">
            <h2 className="title is-2">Picksが選ばれる理由</h2>
          </div>
          <div>
            <div className="columns items">
              <div data-aos="fade-up" className="column item">
                <div className="columns is-mobile">
                  <div className="column is-8">
                    <div className="title has-text-left">
                      お客様を
                      <br />
                      待たせない
                    </div>
                  </div>
                  <div className="column is-relative has-text-right">
                    <div className="images is-1">
                      <Image filename="PicksforPartners/why-picks-1.png" />
                    </div>
                  </div>
                </div>
                <div className="text has-text-left">
                  Picksはスマホで事前注文するため、店頭でお客様を待たせる必要がありません。
                  <br />
                  わずらわしいお会計の手間もなく、店内の混雑を未然に防ぐことができます！
                </div>
              </div>
              <div data-aos="fade-up" className="column item">
                <div className="columns is-mobile">
                  <div className="column is-8">
                    <div className="title has-text-left fts24">
                      テイクアウトの
                      <br />
                      売上を最大化！
                    </div>
                  </div>
                  <div className="column is-relative has-text-right">
                    <div className="images is-2">
                      <Image filename="PicksforPartners/why-picks-2.png" />
                    </div>
                  </div>
                </div>
                <div className="text has-text-left">
                  Picksを導入することで、既存のお客様のご利用頻度や客単価もおおよそ20%上昇します。（※当社利用店の実績）お客様のロイヤリティを高めて、テイクアウトの売上最大化をご支援します。
                </div>
              </div>
            </div>
            <div data-aos="fade-up" className="columns items">
              <div className="column item">
                <div className="columns is-mobile">
                  <div className="column is-8">
                    <div className="title has-text-left fts24">
                      スマホひとつで
                      <br />
                      注文受付・決済
                    </div>
                  </div>
                  <div className="column is-relative has-text-right">
                    <div className="images is-3">
                      <Image filename="PicksforPartners/why-picks-3.png" />
                    </div>
                  </div>
                </div>
                <div className="text has-text-left">
                  必要なものはスマホだけ。 <br />
                  スマホでたった3STEPで注文の受付、決済、お渡しまで完了します。アルバイトでも使えるほどかんたんに操作できます！
                </div>
              </div>
              <div data-aos="fade-up" className="column item">
                <div className="columns is-mobile">
                  <div className="column is-8">
                    <div className="title has-text-left">
                      安心の
                      <br />
                      低価格！
                    </div>
                  </div>
                  <div className="column is-relative has-text-right">
                    <div className="images is-4">
                      <Image filename="PicksforPartners/why-picks-4.png" />
                    </div>
                  </div>
                </div>
                <div className="text has-text-left">
                  自社開発を行うと通常1000万円ほど予算が必要ですが、Picksはお客様のご利用方法に合わせて低価格で安心してご利用いただけるプランをご提案いたします。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default WhyPicks
